/*!
 * Hover-prefetch: prefetch same-origin page HTML when the user hovers/taps a link.
 * Inspired by instant.page (MIT). Scoped and conservative: skips checkout, cart,
 * account flows, external links, and any link explicitly marked data-no-prefetch.
 * When the user actually clicks, the target HTML is already in the browser cache.
 */
(function () {
  var HOVER_DELAY = 65;
  var TOUCH_DELAY = 0;
  var prefetched = new Set();
  var hoverTimer = null;
  var hoverLink = null;
  var SKIP_PREFIXES = [
    '/checkout',
    '/cart',
    '/account',
    '/apps/',
    '/admin',
    '/a/',
    '/search',
  ];
  var SKIP_SUBSTR = ['/cdn/', '.json', '.xml', '/challenge'];

  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (connection) {
    if (connection.saveData) return;
    var type = connection.effectiveType || '';
    if (type === 'slow-2g' || type === '2g') return;
  }
  if (!document.head || !('prefetch' in document.createElement('link').relList) && !('fetch' in window)) {
    return;
  }

  function shouldPrefetch(url) {
    if (!url) return false;
    if (prefetched.has(url)) return false;
    try {
      var u = new URL(url, location.href);
      if (u.origin !== location.origin) return false;
      if (u.pathname === location.pathname && u.search === location.search) return false;
      for (var i = 0; i < SKIP_PREFIXES.length; i++) {
        if (u.pathname.indexOf(SKIP_PREFIXES[i]) === 0) return false;
      }
      for (var j = 0; j < SKIP_SUBSTR.length; j++) {
        if (u.pathname.indexOf(SKIP_SUBSTR[j]) !== -1) return false;
      }
      return true;
    } catch (_) {
      return false;
    }
  }

  function prefetch(url) {
    if (!shouldPrefetch(url)) return;
    prefetched.add(url);
    if ('prefetch' in document.createElement('link').relList) {
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    } else if (window.fetch) {
      fetch(url, { credentials: 'include', priority: 'low' }).catch(function () {});
    }
  }

  function linkFromEvent(e) {
    var node = e.target;
    while (node && node.tagName !== 'A') node = node.parentNode;
    if (!node || node.tagName !== 'A') return null;
    if (node.dataset && node.dataset.noPrefetch !== undefined) return null;
    if (node.target && node.target !== '' && node.target !== '_self') return null;
    if (node.hasAttribute('download')) return null;
    if (!node.href) return null;
    return node;
  }

  function onMouseEnter(e) {
    var link = linkFromEvent(e);
    if (!link) return;
    hoverLink = link;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      if (hoverLink === link) prefetch(link.href);
    }, HOVER_DELAY);
  }

  function onMouseLeave() {
    clearTimeout(hoverTimer);
    hoverLink = null;
  }

  function onTouchStart(e) {
    var link = linkFromEvent(e);
    if (!link) return;
    setTimeout(function () { prefetch(link.href); }, TOUCH_DELAY);
  }

  document.addEventListener('mouseover', onMouseEnter, { capture: true, passive: true });
  document.addEventListener('mouseout', onMouseLeave, { capture: true, passive: true });
  document.addEventListener('touchstart', onTouchStart, { capture: true, passive: true });
})();
